import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const OnboardingPushNotification: Illustration = (props) => (
  <svg viewBox="0 0 320 280" {...illustrationProps(props, { width: 320 })}>
    <path
      fill="#FFC7C7"
      d="M15.168 203.931c-.198 8.16-.387 16.315-.586 24.475l-.087 3.516c-.047 2.086 3.027 2.089 3.077-.005.199-8.16.388-16.314.587-24.475l.086-3.516c.047-2.086-3.027-2.089-3.077.005Z"
    />

    <path
      fill="#FFC7C7"
      d="M4.194 219.28c7.65.047 15.292.092 22.942.14 1.07.005 2.139.01 3.206.023 1.977.008 2.015-3.234.032-3.253l-22.943-.139c-1.07-.005-2.138-.01-3.205-.024-1.977-.008-2.015 3.234-.032 3.253Z"
    />

    <path
      fill="#FFC7C7"
      d="M24.774 206.323c-5.597 5.696-11.183 11.386-16.78 17.083-.8.821-1.606 1.631-2.407 2.453-1.433 1.465.69 3.787 2.124 2.321 5.596-5.696 11.183-11.386 16.78-17.082.8-.822 1.606-1.632 2.406-2.453 1.434-1.466-.689-3.788-2.123-2.322Z"
    />

    <path
      fill="#FFC7C7"
      d="M6.809 209.102c5.314 5.747 10.62 11.5 15.934 17.247l2.226 2.415c1.371 1.49 3.593-.783 2.221-2.273-5.304-5.753-10.62-11.5-15.924-17.253l-2.225-2.415c-1.372-1.49-3.594.783-2.222 2.273l-.01.006Z"
    />

    <path
      fill="#FFB3B3"
      d="M316.933 83.7c-.196-1.263-.86-2.473-1.851-3.167-.953-.662-2.271-.755-3.364-.61-.711.093-1.328.29-1.898.776-.439.373-.747.89-.944 1.46-.523.227-.841.754-.897 1.427-.103 1.2.327 2.411 1.037 3.322.272.538.636.983 1.159 1.263.561.3 1.15.486 1.758.59 1.289.217 2.822.31 3.869-.715.411-.403.617-.92.682-1.48.075-.124.141-.248.197-.372.336-.807.383-1.625.252-2.494Zm-4.944.341s.018-.02 0 0Z"
    />

    <path
      fill="#BEC4FF"
      d="M246.948 20.859c0-2.412 1.049-4.553 3.391-5.61 2.342-1.058 4.979-.415 6.671 1.362 1.553 1.642 1.926 4.35 1.067 6.388-.998 2.353-3.513 3.757-6.09 3.453-2.853-.339-4.987-2.801-5.031-5.593-.026-2.04-3.279-2.048-3.253 0 .052 3.858 2.629 7.293 6.428 8.427 3.8 1.134 7.833-.39 10.063-3.495 2.064-2.876 2.099-7.158.164-10.102-2.108-3.207-6.141-4.781-9.932-3.825-2.082.525-3.869 1.802-5.109 3.495-1.241 1.692-1.614 3.528-1.614 5.491 0 1.963 3.253 2.048 3.253 0l-.008.009ZM151.809 262.197a83.092 83.092 0 0 1-2.998-2.968c-.65-.687-.661-1.689-.029-2.394.597-.664 1.78-.671 2.394-.029a83.604 83.604 0 0 0 2.961 2.934 85.143 85.143 0 0 1 3.104-3.141c.686-.649 1.689-.661 2.393-.029.664.597.671 1.781.029 2.394a86.352 86.352 0 0 0-3.068 3.104 86.788 86.788 0 0 0 3.269 2.97c.715.614.608 1.751.029 2.394-.638.714-1.722.6-2.394.029a82.17 82.17 0 0 1-3.233-2.935 84.82 84.82 0 0 0-2.835 3.127c-.613.715-1.75.608-2.394.029-.713-.638-.599-1.722-.028-2.394a79.302 79.302 0 0 1 2.8-3.091Z"
    />

    <path
      fill="#178000"
      d="M82.552 60.42 16.738 98.355a9.004 9.004 0 0 0-3.304 12.297l79.51 137.934a9.004 9.004 0 0 0 12.297 3.305l65.813-37.937a9.003 9.003 0 0 0 3.304-12.298L94.849 63.723a9.004 9.004 0 0 0-12.297-3.304Z"
    />

    <path
      fill="#22AE00"
      d="M90.355 55.926 24.542 93.863a9.004 9.004 0 0 0-3.304 12.297l79.509 137.934a9.004 9.004 0 0 0 12.298 3.304l65.813-37.936a9.004 9.004 0 0 0 3.304-12.298L102.653 59.23a9.005 9.005 0 0 0-12.298-3.304Z"
    />

    <path
      fill="#76C82E"
      d="M98.029 69.322 32.29 107.216a5.148 5.148 0 0 0-1.889 7.031l73.727 127.903a5.15 5.15 0 0 0 7.032 1.889l65.738-37.893a5.148 5.148 0 0 0 1.889-7.032L105.06 71.211a5.148 5.148 0 0 0-7.031-1.89Z"
    />

    <path
      fill="#22AE00"
      d="M131.343 226.393c6.207-2.991 18.633-10.695 24.836-13.696.977-.478 1.112-1.972.569-2.803-.669-1.005-1.816-1.05-2.803-.569-6.207 2.991-18.633 10.695-24.837 13.696-.977.478-1.112 1.972-.568 2.803.668 1.005 1.816 1.05 2.803.569Z"
    />

    <path
      fill="#2E6123"
      d="M22.401 122.362c2.99 6.206 7.43 11.645 10.431 17.848.478.977 1.972 1.112 2.803.569 1.006-.668 1.05-1.816.569-2.803-2.99-6.207-7.43-11.645-10.43-17.849-.479-.977-1.973-1.112-2.804-.568-1.005.668-1.05 1.815-.569 2.803Z"
    />

    <path
      fill="#178000"
      d="M65.76 82.564c-2.921 1.865-5.841 3.73-8.954 5.23-.987.48-2.135.436-2.803-.57-.544-.83-.409-2.325.568-2.802 3.092-1.496 5.994-3.349 8.895-5.202 2.92-1.864 5.84-3.73 8.954-5.23.987-.48 2.135-.436 2.803.57.543.83.408 2.325-.569 2.802-3.091 1.496-5.993 3.35-8.895 5.202Zm-14.438 8.41c.198-.111.375-.255.536-.432.309-.407.374-.519.52-1.008.06-.2.064-.429.052-.64a2.586 2.586 0 0 0-.408-1.25 2.674 2.674 0 0 0-.96-.853c-.359-.2-.842-.291-1.258-.28-.48.02-.958.188-1.361.445-.193.13-.372.3-.535.454l-.006.006c-.052.05-.093.098-.14.159-.142.193-.282.386-.396.594l-.041.081a1.918 1.918 0 0 0-.21 1.02c-.005-.058.006.012.024.124.022.14.055.344.08.443l.027.081.054.121c.063.145.129.296.216.426.128.185.277.363.446.5a6.937 6.937 0 0 0 .485.34c.021.017.045.027.067.036l.028.012.045.019c.178.074.407.17.601.19.541.06.667.065 1.203-.065l.082-.026a3.11 3.11 0 0 0 .567-.276 1.68 1.68 0 0 0 .282-.222Z"
    />

    <rect
      width="148.043"
      height="45.148"
      x="40.942"
      y="115.005"
      fill="#B8E682"
      rx="4"
      transform="rotate(-30 40.942 115.005)"
    />

    <path
      fill="#EDF9E1"
      d="M78.327 136.038c6.95-4.012 9.369-12.834 5.403-19.703s-12.815-9.185-19.765-5.173c-6.95 4.012-9.368 12.834-5.402 19.703s12.815 9.185 19.764 5.173Z"
    />

    <path
      fill="#76C82E"
      d="m74.856 124.111-3.24-2.279 1.578-7.825-2.87 1.658-1.702 8.926-3.44-5.958-2.377 1.373 7.387 12.795 2.377-1.373-2.139-3.705.612-3.029 2.468 1.729c2.123 1.479 4.224 2.118 6.272.936.329-.19.71-.458.962-.701l-1.182-2.047s-.223.204-.57.404c-1.302.749-2.407.314-4.136-.904Z"
    />

    <path
      fill="#EDF9E1"
      d="M159.028 78.128c-.658 1.107-1.907 1.509-3.122 1.847-.264.074-.527.145-.788.216-1.281.347-2.535.687-3.78 1.296-1.425.698-2.628 1.708-3.826 2.713-1.22 1.025-2.435 2.045-3.875 2.726-.681.32-1.391.492-2.104.666-.683.166-1.368.333-2.033.63-1.195.537-2.031 1.323-2.903 2.142-.317.298-.639.6-.984.897-1.014.88-2.254 1.497-3.467 2.101l-.58.29c-1.618.824-3.156 1.712-4.523 2.898-.398.345-.636.704-.745 1.051-.695.826-1.787 1.172-2.852 1.468-.264.074-.527.145-.788.216-1.282.347-2.535.688-3.78 1.297-1.426.697-2.628 1.707-3.826 2.712-1.22 1.025-2.435 2.045-3.875 2.726-.681.32-1.391.493-2.104.666-.683.167-1.368.333-2.033.631-1.195.536-2.031 1.322-2.903 2.141-.317.298-.639.601-.984.897-1.014.88-2.255 1.497-3.467 2.101l-.58.29c-1.618.824-3.156 1.713-4.523 2.898-2.223 1.923.563 4.306 2.796 2.377 1.255-1.091 2.742-1.844 4.235-2.601 1.521-.771 3.047-1.545 4.34-2.681.254-.223.489-.473.726-.725.345-.366.691-.735 1.099-1.023.559-.391 1.178-.539 1.799-.688l.236-.057c1.549-.376 2.982-.928 4.351-1.839.881-.586 1.699-1.253 2.512-1.916 1.647-1.343 3.277-2.671 5.384-3.283l.624-.179c2.799-.799 5.883-1.679 7.428-4.304l.03-.053c1.188-.956 2.557-1.65 3.931-2.346 1.521-.771 3.047-1.545 4.34-2.68.254-.224.49-.474.726-.726.345-.367.691-.735 1.099-1.023.559-.391 1.179-.54 1.799-.688l.236-.057c1.549-.376 2.982-.928 4.351-1.84.881-.585 1.699-1.252 2.512-1.915 1.647-1.343 3.277-2.671 5.384-3.283.206-.06.414-.119.623-.178h.001c2.8-.8 5.883-1.68 7.428-4.305.59-1.002.52-2.086-.511-2.538-.878-.386-2.476.029-3.065 1.03l.031.005Zm-66.197 29.614c.657-1.107 1.906-1.509 3.121-1.847.264-.074.527-.145.788-.216 1.282-.347 2.535-.688 3.78-1.297 1.426-.697 2.628-1.707 3.826-2.712 1.22-1.025 2.435-2.045 3.875-2.726.681-.32 1.391-.493 2.104-.666.683-.167 1.368-.334 2.033-.631 1.195-.536 2.031-1.322 2.903-2.142.317-.297.639-.6.984-.896 1.014-.88 2.255-1.497 3.467-2.101l.58-.29c1.618-.824 3.156-1.713 4.523-2.898 2.223-1.923-.562-4.306-2.796-2.377-1.255 1.09-2.742 1.844-4.235 2.601-1.521.771-3.047 1.545-4.34 2.68-.254.224-.489.474-.726.726-.345.366-.691.735-1.099 1.023-.559.39-1.179.54-1.799.688a33.67 33.67 0 0 0-.236.057c-1.549.376-2.982.928-4.351 1.84-.881.585-1.699 1.251-2.512 1.915-1.647 1.343-3.277 2.671-5.384 3.282-.205.06-.413.119-.623.179-2.8.8-5.884 1.68-7.43 4.305-.589 1.002-.519 2.086.512 2.538.878.386 2.476-.029 3.065-1.031l-.03-.004Z"
    />

    <path
      fill="#FFDE9B"
      d="M192.663 178.295c18.121 31.387 58.255 42.141 89.642 24.02 31.386-18.121 42.14-58.255 24.019-89.642-18.121-31.386-58.255-42.14-89.641-24.02-10.024 5.788-17.944 13.821-23.491 23.097l-20.589 2.78c-3.21.433-4.601 4.304-2.4 6.681l14.267 15.413c-1.908 13.922.623 28.56 8.193 41.671Z"
    />

    <circle
      cx="6.981"
      cy="6.981"
      r="6.981"
      fill="#EE7903"
      transform="scale(-1 1) rotate(-18.584 353.086 789.154)"
    />

    <path
      fill="#FEA628"
      d="m272.065 175.619.088.448a5.997 5.997 0 0 1-1.316 5.041l-1.181 1.39a6 6 0 0 1-8.458.686l-38.185-32.456a6.001 6.001 0 0 1-.685-8.458l1.348-1.586a5.996 5.996 0 0 1 4.34-2.109l.566-.022a25.999 25.999 0 0 0 18.806-9.142l5.093-5.991c6.961-8.19 19.244-9.186 27.434-2.225 8.19 6.961 9.186 19.244 2.225 27.434l-4.372 5.143a26 26 0 0 0-5.703 21.847Z"
    />

    <path
      stroke="#fff"
      d="M269.195 121.853c-13.239-2.61-20.184 16.696-27.828 18.876"
    />

    <path
      fill="#fff"
      d="M212.806 122.54a1.75 1.75 0 0 0-1.224 2.151l1.951 7.109a1.75 1.75 0 1 0 3.375-.927l-1.951-7.109a1.75 1.75 0 0 0-2.151-1.224Zm-13.948 10.153a1.75 1.75 0 0 0 .732 2.364l7.947 4.191a1.75 1.75 0 1 0 1.633-3.096l-7.948-4.191a1.75 1.75 0 0 0-2.364.732Zm7.409 13.164a1.75 1.75 0 1 1 .32 3.486l-8.853.812a1.75 1.75 0 0 1-.32-3.485l8.853-.813Z"
    />

    <path
      stroke="#FEA628"
      d="M281.103 126.325c4.087-1.206 5.672-6.378 3.168-9.271-2.77-3.199-10.302-2.741-10.059 7.775"
    />
  </svg>
);
